var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMetroInsertTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-insert-template",
    "data-name": "Icon metro-insert-template",
    d: "M20.571,10.928h6v3h-6Zm9,0h6v3h-6Zm15,0v12h-9v-3h6v-6h-3v-3Zm-27,9h6v3h-6Zm9,0h6v3h-6Zm-15-6v6h3v3h-6v-12h9v3Zm9,15h6v3h-6Zm9,0h6v3h-6Zm15,0v12h-9v-3h6v-6h-3v-3Zm-27,9h6v3h-6Zm9,0h6v3h-6Zm-15-6v6h3v3h-6v-12h9v3Zm36-27h-42v42h42v-42Zm3-3v48h-48v-48h48Z",
    transform: "translate(-2.571 -1.928)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetroInsertTemplate);
export default __webpack_public_path__ + "static/media/icon-metro-insert-template.793a8e5e8784df8f89c0132e057ccd61.svg";
export { ForwardRef as ReactComponent };